// https://shopify.dev/api/multipass
class LomiMultipassClient {
    constructor(lomiApiClient) {
        this.apiClient = lomiApiClient;
    }

    createUrl(authToken, returnToUrl, storeDomain, onSuccess, onError) {
        this.apiClient.post(
            'v2/shopify/multipass',
            {
                returnToUrl,
                storeDomain
            },
            onSuccess,
            onError,
            authToken
        );
    }
}
